module.exports = __webpack_public_path__ + "4a85e3d24a59a1393d96860dc94b1d9e.png";